import script from "./colorSearch.vue?vue&type=script&setup=true&name=colorSearch&lang=js"
export * from "./colorSearch.vue?vue&type=script&setup=true&name=colorSearch&lang=js"

const __exports__ = script;

export default __exports__